export default "__VITE_ASSET__CZEX8B$x__"